import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, CopyIcon, GiftIcon, XIcon } from 'lucide-react';
interface ScratchAndWinModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ScratchAndWinModal({
  isOpen,
  onClose
}: ScratchAndWinModalProps) {
  const [isRevealed, setIsRevealed] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const couponCode = 'SCRATCH15';
  useEffect(() => {
    if (isOpen) {
      setIsRevealed(false);
      setIsCopied(false);
    }
  }, [isOpen]);
  const copyCoupon = async () => {
    await navigator.clipboard.writeText(couponCode);
    setIsCopied(true);
  };
  return <AnimatePresence data-id="element-3626" data-mp="umyu18mwzo5v">
      {isOpen && <div className="fixed inset-0 z-[200] flex items-end justify-center bg-black/50 p-4 md:items-center" role="dialog" aria-modal="true" aria-labelledby="scratch-title" data-id="element-3627" data-mp="unqryq3zhxzb">
          <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 16
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl md:p-6" data-id="element-3628" data-mp="2p1hvr8zmtnmu">
            <div className="flex items-start justify-between gap-4" data-id="element-3629" data-mp="2uzuekk32iy3w">
              <div className="flex items-center gap-3" data-id="element-3630" data-mp="2q1j54agoqpm7">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-pharmacy-light text-pharmacy" data-id="element-3631" data-mp="2q45m10pguhh3">
                  <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-3632" data-mp="1xddjzmlpyylu" />
                </span>
                <div data-id="element-3633" data-mp="1xfq68byifv4p">
                  <p className="text-xs font-bold uppercase tracking-wide text-pharmacy" data-id="element-3634" data-mp="2bdoagoj4ab6h">Instant reward</p>
                  <h2 id="scratch-title" className="mt-0.5 text-xl font-bold text-gray-900" data-id="element-3635" data-mp="27bbh6zlk45ql">Scratch & Win</h2>
                </div>
              </div>
              <button type="button" onClick={onClose} className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy" aria-label="Close scratch and win" data-id="element-3636" data-mp="3muekyjukpp5w">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-3637" data-mp="2perwqgo26msw" />
              </button>
            </div>

            <div className="mt-6 rounded-xl border border-[#DCE9DE] bg-[#F8FCF8] p-5 text-center" data-id="element-3638" data-mp="2tdhl14amxorb">
              {isRevealed ? <div data-id="element-3639" data-mp="21o62bs6z911d">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-pharmacy text-white" data-id="element-3640" data-mp="21nmho3pxzyjn">
                    <CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-3641" data-mp="25og9v9af3zic" />
                  </span>
                  <p className="mt-3 text-sm font-medium text-gray-600" data-id="element-3642" data-mp="2aiaohyb61oak">You unlocked</p>
                  <p className="mt-1 text-3xl font-black text-pharmacy" data-id="element-3643" data-mp="1dy209p9ft9ch">15% OFF</p>
                  <button type="button" onClick={copyCoupon} className="mt-4 inline-flex items-center gap-2 rounded-lg border border-dashed border-pharmacy bg-white px-4 py-2.5 font-mono text-sm font-bold text-gray-900 transition-colors duration-150 hover:bg-pharmacy-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy" data-id="element-3644" data-mp="1hzn6wsvdore8">
                    {couponCode}
                    {isCopied ? <CheckIcon className="h-4 w-4 text-pharmacy" aria-hidden="true" data-id="element-3645" data-mp="rhrxlo33d7mu" /> : <CopyIcon className="h-4 w-4 text-pharmacy" aria-hidden="true" data-id="element-3646" data-mp="rk4o4pmx0qbi" />}
                  </button>
                  <p className="mt-3 text-xs text-gray-500" data-id="element-3647" data-mp="mpi9mdljehn7">{isCopied ? 'Coupon copied. Apply it at checkout.' : 'Tap the code to copy it.'}</p>
                </div> : <div data-id="element-3648" data-mp="dok4tt39y63k">
                  <p className="text-sm text-gray-600" data-id="element-3649" data-mp="8rk9ac41wlqp">Reveal your exclusive offer</p>
                  <button type="button" onClick={() => setIsRevealed(true)} className="mt-4 flex h-36 w-full items-center justify-center rounded-lg border-2 border-dashed border-[#91C99C] bg-pharmacy px-4 text-lg font-black tracking-wide text-white transition-colors duration-150 hover:bg-pharmacy-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy focus-visible:ring-offset-2" data-id="element-3650" data-mp="8tel90xch3in">
                    SCRATCH TO REVEAL
                  </button>
                </div>}
            </div>

            <button type="button" onClick={onClose} className="mt-5 w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-bold text-gray-700 transition-colors duration-150 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pharmacy focus-visible:ring-offset-2" data-id="element-3651" data-mp="1l6ld7flqhb6k">
              Continue shopping
            </button>
          </motion.div>
        </div>}
    </AnimatePresence>;
}